import { FC, useCallback, useEffect, useRef, useState, useMemo } from "react";
import styled, { css, useTheme } from "styled-components";
import {Avatar, Colors, CommonInput, FInter, FlexBox, Fonts, INPUT_TYPES, useBreakpoint, useToasts} from "@brg/ui";
import { useTranslation } from "react-i18next";
import {API, Designer, DesignerAPI, TeamAPI} from "@brg/api";
import {useParams, useRouteMatch} from "react-router-dom";
import { LayoutConst } from "core";
import { computeDesigner } from "shared/helpers/computeData";
import { AppTester } from "supporting";
import { AuthorsOffsetContainer } from "shared/pages/projectEdit/styles";
import { bProfile, useProfile } from "@brg/auth";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";

export type AuthorT = Designer<'Local'> & { disabled?: boolean };

export type AuthorActionsT = {
  action: string,
  removedValue?: AuthorT
}

export const SearchInput = styled.input<{ footer?: boolean, isProjectEdit?: boolean, isTeamEdit?: boolean, isPresentationLMS?: boolean, isPresentation?: boolean, isTeacherLMS?: boolean }>`
  width: 100%;
  background-color: transparent;
  ${Fonts.Inter.smallText};
  color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
  outline: none !important;
  border: none;
  border-radius: 3px;
  transition: all 0.2s;
  height: 48px;
  border: 1px solid transparent;
  padding-left: 36px;
  // padding-left: 28px;

  ::placeholder {
    color: ${({ theme }) => theme.projectEdit.mobile.inputs.placeholder};
    // padding-left: 44px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ isProjectEdit, isPresentationLMS, isTeacherLMS }) => isProjectEdit ? css`

    height: ${isPresentationLMS && !isTeacherLMS ? '32px' : '44px'};

    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
      ::placeholder {
        font-size: 13px;
        line-height: 16px;
        font-weight: 400;
      }
    ` : null};
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isTeamEdit }) => isTeamEdit ? css`
      height: 40px !important;
    ` : null};
  }

  ${({ isPresentationLMS }) => isPresentationLMS ? css`
      background: ${Colors.geoWhite100};

    @media (max-width: ${LayoutConst.screen.m}px) {
      background: ${Colors.galBlack5};
    }
  ` : null};
`;

export const SearchLine = styled(FlexBox)`
  background: ${(p) => p.theme.navigationBar.search.line};
  height: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

//todo remove static height

export const SearchWrapper = styled(FlexBox)<{ out?: boolean, footer?: boolean, orientation?: 'row' | 'column' | 'wide', isOpen?: boolean, isLMS?: boolean, isPresentation?: boolean, isTeacherLMS?: boolean, isProjectEditPage?: boolean, isStudent?: boolean }>`
  margin-left: 0;
  position: relative;
  flex-flow: column;
  width: 100%;
  margin-top: 0;

  .ui-input_container{
    padding: 0 0 0 16px;

    div > div {
      min-width: auto;
      width: auto;
      padding-right: 12px;
    }
  }

  div {
    color: ${({ theme }) => theme.projectEdit.label};
  }

  > div > div:first-child {
    width: ${({ isProjectEditPage }) => isProjectEditPage ? '160px' : '224px'};
    min-width: ${({ isProjectEditPage }) => isProjectEditPage ? '160px' : '224px'};

  @media (max-width: 1440px), (max-height: 920px) {
    width: ${({ isProjectEditPage }) => isProjectEditPage ? '130px' : '160px'};
    min-width: ${({ isProjectEditPage }) => isProjectEditPage ? '130px' : '160px'};
  }

  ${({ orientation }) => orientation === 'column' ? css`
    width: 100% !important;
    min-width: 100% !important;
  ` : null};
}
`;

export const SearchFlexBox = styled(FlexBox)<{footer?: boolean}>`
  height: ${({footer}) => footer ? '24' : '48'}px !important;
  position: relative;
  align-items: center;
  color: ${(p) => p.theme.navigationBar.search.colorFlex};
  // min-height: 100%;
`;

export const NavbarSearchWrapper = styled.div<{footer?: boolean, isPresentationLMS?: boolean}>`
  display: flex;
  position: absolute;
  left: 16px;
  top: 0;
  cursor: pointer;
  // opacity: 0.47;
  transition: opacity 0.2s;
  align-items: center;
  justify-content: center;
  place-items: center;
  height: 100%;

  svg {
    * {
      fill: ${(p) => p.theme.navigationBar.search.svg} !important;
    }
  }
  &:hover {
    svg {
      * {
        fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
      }
    }
  }

  svg {
    width: ${({footer}) => footer ? '14' : '16'}px !important;
    height: ${({footer}) => footer ? '14' : '16'}px !important;
  }
`;

export const NavbarResultsWrapper = styled.div<{footer?: boolean, isLMS?: boolean}>`
  // position: absolute;
  background-color: ${(p) => p?.isLMS ? '#FEFEFE' : p.theme.mainSearchBar.input.bg};
  max-height: 200px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: ${({ isLMS }) => isLMS ? '0 0px 6px ' : '0 6px 6px '};
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12);
  margin-bottom: 50px;

  ::-webkit-scrollbar {
    width: 3px; /* ширина scrollbar */
    height: 68px;
  }
  ::-webkit-scrollbar-track {
      background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 10px; /* закругления плашки */
      background-color: ${({ theme }) => theme.scroll.bg};
  }
`;

export const NavbarResultsItem = styled.div<{ isSelected?: boolean, isLMS?: boolean, disabled?: boolean }>`
  display: flex;
  width: 100%;
  height: 52px;
//   border-bottom: 1px solid ${(p) => p.theme.app.ten};
  cursor: ${({disabled}) => disabled ? 'normal' : 'pointer'};
  transition: background-color 0.2s;
  background-color: ${(p) => p?.isLMS ? '#FEFEFE' : p.theme.mainSearchBar.input.bg};
  :hover {
    background-color: ${(p) => p?.disabled ? p.theme.mainSearchBar.input.bg : p.theme.app.ten};
  }
  :active {
    background-color: ${Colors.galBlack31};
  }

  ${({ disabled }) => disabled && css`
    pointer-events: none;
  `}

  .check-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
`;

const DropWrapper = styled.div<{ orientation?: string, isLMS?: boolean }>`
  position: absolute;
  top: 48px;
  left: 0;
  height: auto;
  width: 100%;
  z-index: 400;

  .search-msg {
    color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
    ${({ isLMS }) => isLMS && css`
      background-color: #FEFEFE;
    `};
  }

  .item {
    :not(.search-msg) {
      :hover {
        background-color: ${({ theme, isLMS }) => isLMS ? '#F2F2F2' : theme.mainSearchBar.text.hover.color};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    top: 40px;
  }
`;

const InputWrapper = styled(FlexBox)<{isPresentationLMS?: boolean}>`
  padding: 0 10px;
  position: relative;
  width: 100%;

  svg path {
    cursor: pointer;
    fill: ${Colors.galBlack47};
    transition: color 0.2s;
  }
  .close-btn-wrap {
    &:hover {
      svg path {
        fill: ${Colors.galBlack100};
        transition: color 0.2s;
      }
    }
  }

  ${({ isPresentationLMS }) => isPresentationLMS ? css`
      padding: 0!important;
    ` : null};
`;

const Text = styled(FInter.SmallTextDiv)`
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
`;

const CloseIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);

  svg {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  svg path {
    fill: ${({ theme }) => theme.projectEdit.search.inputs.fill};
    transition: fill 0.2s;
  }

  :hover {
    svg path {
      fill: ${({ theme }) => theme.projectEdit.search.inputs.hoverFill};
      transition: fill 0.2s;
    }
  }
`;

export interface MainMenuSearchBarProps {
  editing: boolean;
  value: AuthorT[];
  label?: string;
  required?: boolean;
  orientation?: 'row' | 'column' | 'wide';
  onSearch?: (searchValue: string) => Promise<boolean>;
  onAddClick: (data: AuthorT[], { action, removedValue } : AuthorActionsT) => void;
  onResetClick: () => void;
  onSelect?: (id: string) => boolean;
  isProjectEdit?: boolean;
  teamId?: string;
  infoText?: string;
  isTeamEdit?: boolean;
  isLMS?: boolean;
  isPresentationLMS?: boolean;
  ignoreContext?: boolean;
  isPresentation?: boolean;
  isTeacherLMS?: boolean;
  placeholder?: string;
  errorMsg?: string;
  teamModerationType?: number;
  customStyles?: any;
  disabledFocus?: boolean;
  localOptions?: Designer[];
  excludeAccountIds?: string[];
}

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps || []), delay]);
};

export const AuthorsMobileSearch: FC<MainMenuSearchBarProps> = ({
  editing = false, 
  ignoreContext, 
  teamId,
  label, 
  isTeacherLMS, 
  value, 
  orientation,
  required,
  isPresentationLMS, 
  errorMsg, 
  onAddClick, 
  onResetClick, 
  onSelect, 
  infoText,
  placeholder, 
  isLMS, 
  teamModerationType,
  customStyles,
  disabledFocus = false,
  localOptions,
  excludeAccountIds,
}) => {
  const searchRef = useRef<any>(null);
  const resultRef = useRef<any>(null);
  const theme = useTheme();
  const toasts = useToasts();
  const [designers, setDesigners] = useState<Designer[]>([]);
  const is568px = useBreakpoint(568)
  const { i18n, t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [isEmpty, setIsEmpty] = useState(false);
  const { id } = useParams<{ id: string }>();
  const isEditLMSExamPage = !!useRouteMatch("/competition-edit");
  const isPro = AppTester.isProDeziiign();
  const isProjectEditPage = !!useRouteMatch("/edit");
  const isBookEditPage = !!useRouteMatch("/books/edit");
  const isEditPage = isProjectEditPage || isBookEditPage;

  const profile = useProfile()
  const isStudent = profile && bProfile.isStudent(profile)

  const showClose = useMemo(() => (!!searchText?.length), [searchText])

  const excludedIds = useMemo(
    () => new Set((excludeAccountIds || []).filter(Boolean)),
    [excludeAccountIds],
  );

  const isExcludedDesigner = useCallback((designer?: Designer | AuthorT | null) => {
    if (!designer || excludedIds.size < 1) {
      return false;
    }
    return excludedIds.has(designer.accountId) || excludedIds.has(designer.designerId);
  }, [excludedIds]);
  
  useDebouncedEffect(
    () => {
      if (searchText.length < 2) {
        setDesigners([]);
        setIsEmpty(false);
        return;
      }

      if (localOptions) {
        const q = searchText.trim().toLowerCase();
        const filtered = localOptions.filter((v) => {
          if (isExcludedDesigner(v)) {
            return false;
          }
          const cv = computeDesigner(v, { showFullName: true });
          const haystack = [cv.fullName, cv.name, cv.surName, cv.middleName, (v as any)?.nameCache]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();
          return haystack.includes(q);
        });
        setDesigners(filtered);
        setIsEmpty(filtered.length < 1);
        return;
      }

      (isTeacherLMS
        ? TeamAPI.OwnersAutoComplete({
            key: searchText,
            teamId: teamId || id,
          })
        : isPresentationLMS
        ? TeamAPI.AutoComplete({ key: searchText, teamId: teamId || id })
        : isLMS && isEditLMSExamPage
        ? DesignerAPI.AutoComplete({ key: searchText, ignoreContext: true })
        : (isLMS)
        ? TeamAPI.AutoComplete({ key: searchText, teamId: teamId || id })
        : (teamModerationType === 3 || ignoreContext)
        ? DesignerAPI.AutoComplete({ key: searchText, ignoreContext: true })
        : DesignerAPI.AutoComplete({ key: searchText })
      )
        .then((v) => v.json())
        .then((v) => API.toLang<Designer[]>(v, i18n.language))
        .then((v) => {
          // @ts-ignore
          if (v?.ErrorStatusCode === 500) {
            setDesigners([]);
            return;
          }
          const filtered = (v || []).filter((designer) => !isExcludedDesigner(designer));
          setDesigners(filtered);
          setIsEmpty(filtered.length < 1);
        });
    },
    [searchText, i18n.language, isLMS, isTeacherLMS, isPresentationLMS, id, teamId, localOptions, isExcludedDesigner],
    700
  );

  useEffect(() => {
    if (searchRef && editing && !is568px && !isPro && !disabledFocus) {
      searchRef.current?.focus();
    }
  }, [searchRef, editing, isPro])

  const resetSearchMode = () => {
    setSearchText('');
    onResetClick();
  }

  const resetText = () => {
    setSearchText('');
    searchRef.current.value = ''
  }

  const handleAddClick = (data: AuthorT[], { action } : AuthorActionsT) => {
    const added = data[data?.length - 1]
    const { designerId } = added || {}
    const isExist = data?.filter((i) => i?.designerId === designerId)?.length > 1

    if (isExcludedDesigner(added)) {
      return;
    }

    if (isExist) {
      toasts.error(errorMsg || 'Нельзя добавить двух одинаковых соавторов');
      return;
    }
    onAddClick && onAddClick(data, { action });
    resetSearchMode(); 
  }

  const handleOnBlurClick = useCallback((ev: any) => {
    if (!resultRef?.current || !designers?.length && !showClose) {
      resetSearchMode();
      return; 
    }
  }, [resetSearchMode, resultRef, designers])

  const handleClose = (ev: any) => {
    if (searchRef.current && !searchRef.current?.contains(ev.target)) {
      resetSearchMode();
      searchRef.current.value = ''
    }
  }

  useEffect(() => {
    window.addEventListener('click', handleClose)
    return () => {
      window.removeEventListener('click', handleClose)
    }
  }, []);

  return (
    <SearchWrapper isProjectEditPage={isEditPage} isStudent={isStudent} orientation={orientation}>
      <CommonInput 
        onChange={(e: any) => setSearchText(e.target.value?.trimLeft())}
        onBlur={handleOnBlurClick}
        ref={searchRef}
        value={searchText}
        type={INPUT_TYPES.search}
        required={required}
        placeholder={placeholder || t('choose')}
        label={label}
        infoText={infoText}
        onWhiteBG
        className="type-theme-input"
        orientation={orientation}
        resultComponent={(
          <>
          {searchText.length > 0 ? (
            <DropWrapper isLMS={isPresentationLMS} className="result-dropdown-wrapper">
            <NavbarResultsWrapper className={'dropdown-wrapper'} style={customStyles} ref={resultRef} isLMS={isPresentationLMS}>
              {designers.map((v) => {
                const cv = computeDesigner(v, { showFullName: true });
                const isSelected = onSelect && onSelect(v?.accountId);
                return (
                  <NavbarResultsItem
                    isLMS={isPresentationLMS}
                    onClick={() => {
                      if (!isSelected) {
                        handleAddClick([...value, v], { action: 'select-option'});
                      }
                    }}
                    key={v.accountId}
                    style={{ marginBottom: '4px', ...customStyles }}
                    className={'item'}
                  >
                    <FlexBox align={"center"} gx={8} style={{ padding: "2px 0 2px 9px", position: 'relative' }} width={'100%'}>
                      <FlexBox width={48} height={48} style={{ borderRadius: '3px' }}>
                        <Avatar {...cv} rounded />
                      </FlexBox>
                      <Text className={'dropdown-wrapper__text'} color={customStyles?.color || theme.mainSearchBar?.text?.color}>{cv.fullName}</Text>
                      {isSelected && (
                        <svg className={'check-icon'} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z" fill={theme.mainSearchBar?.text?.color || '#151514'} />
                        </svg>
                      )}
                    </FlexBox>
                  </NavbarResultsItem>
                );
              })}
              {designers.length < 1 && searchText.length < 2 && (
                <NavbarResultsItem  style={customStyles} className="search-msg">
                  <FlexBox
                    align={"center"}
                    width={"100%"}
                    justify={"center"}
                    gx={8}
                  >
                    <Text className={'dropdown-wrapper__text'}>
                      {t("text.more2chars")}
                    </Text>
                  </FlexBox>
                </NavbarResultsItem>
              )}
              {designers.length < 1 && searchText.length >= 2 && !isEmpty && (
                <NavbarResultsItem  style={customStyles} className="search-msg">
                  <FlexBox
                    align={"center"}
                    width={"100%"}
                    justify={"center"}
                    gx={8}
                  >
                    <Text className={'dropdown-wrapper__text'}  >{t("text.loading")}</Text>
                  </FlexBox>
                </NavbarResultsItem>
              )}
              {designers.length < 1 && searchText.length >= 2 && isEmpty && (
                <NavbarResultsItem  style={customStyles} className="search-msg" disabled>
                  <FlexBox
                    align={"center"}
                    width={"100%"}
                    justify={"center"}
                    gx={8}
                  >
                    <Text className={'dropdown-wrapper__text'}>
                    {t("text.notfound")}
                    </Text>
                  </FlexBox>
                </NavbarResultsItem>
              )}
            </NavbarResultsWrapper>
            </DropWrapper>
          ) : null}
          </>
        )}
      />
    </SearchWrapper>
  );
};
import { FC, useCallback, useEffect, useRef, useState, useMemo } from "react";
import styled, { css, useTheme } from "styled-components";
import {Avatar, Colors, CommonInput, FInter, FlexBox, Fonts, INPUT_TYPES, useBreakpoint, useToasts} from "@brg/ui";
import { useTranslation } from "react-i18next";
import {API, Designer, DesignerAPI, TeamAPI} from "@brg/api";
import {useParams, useRouteMatch} from "react-router-dom";
import { LayoutConst } from "core";
import { computeDesigner } from "shared/helpers/computeData";
import { AppTester } from "supporting";
import { AuthorsOffsetContainer } from "shared/pages/projectEdit/styles";
import { bProfile, useProfile } from "@brg/auth";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";

export type AuthorT = Designer<'Local'> & { disabled?: boolean };

export type AuthorActionsT = {
  action: string,
  removedValue?: AuthorT
}

export const SearchInput = styled.input<{ footer?: boolean, isProjectEdit?: boolean, isTeamEdit?: boolean, isPresentationLMS?: boolean, isPresentation?: boolean, isTeacherLMS?: boolean }>`
  width: 100%;
  background-color: transparent;
  ${Fonts.Inter.smallText};
  color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
  outline: none !important;
  border: none;
  border-radius: 3px;
  transition: all 0.2s;
  height: 48px;
  border: 1px solid transparent;
  padding-left: 36px;
  // padding-left: 28px;

  ::placeholder {
    color: ${({ theme }) => theme.projectEdit.mobile.inputs.placeholder};
    // padding-left: 44px;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ isProjectEdit, isPresentationLMS, isTeacherLMS }) => isProjectEdit ? css`

    height: ${isPresentationLMS && !isTeacherLMS ? '32px' : '44px'};

    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
      ::placeholder {
        font-size: 13px;
        line-height: 16px;
        font-weight: 400;
      }
    ` : null};
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    ${({ isTeamEdit }) => isTeamEdit ? css`
      height: 40px !important;
    ` : null};
  }

  ${({ isPresentationLMS }) => isPresentationLMS ? css`
      background: ${Colors.geoWhite100};

    @media (max-width: ${LayoutConst.screen.m}px) {
      background: ${Colors.galBlack5};
    }
  ` : null};
`;

export const SearchLine = styled(FlexBox)`
  background: ${(p) => p.theme.navigationBar.search.line};
  height: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;

//todo remove static height

export const SearchWrapper = styled(FlexBox)<{ out?: boolean, footer?: boolean, orientation?: 'row' | 'column' | 'wide', isOpen?: boolean, isLMS?: boolean, isPresentation?: boolean, isTeacherLMS?: boolean, isProjectEditPage?: boolean, isStudent?: boolean }>`
  margin-left: 0;
  position: relative;
  flex-flow: column;
  width: 100%;
  margin-top: 0;

  .ui-input_container{
    padding: 0 0 0 16px;

    div > div {
      min-width: auto;
      width: auto;
      padding-right: 12px;
    }
  }

  div {
    color: ${({ theme }) => theme.projectEdit.label};
  }

  > div > div:first-child {
    width: ${({ isProjectEditPage }) => isProjectEditPage ? '160px' : '224px'};
    min-width: ${({ isProjectEditPage }) => isProjectEditPage ? '160px' : '224px'};

  @media (max-width: 1440px), (max-height: 920px) {
    width: ${({ isProjectEditPage }) => isProjectEditPage ? '130px' : '160px'};
    min-width: ${({ isProjectEditPage }) => isProjectEditPage ? '130px' : '160px'};
  }

  ${({ orientation }) => orientation === 'column' ? css`
    width: 100% !important;
    min-width: 100% !important;
  ` : null};
}
`;

export const SearchFlexBox = styled(FlexBox)<{footer?: boolean}>`
  height: ${({footer}) => footer ? '24' : '48'}px !important;
  position: relative;
  align-items: center;
  color: ${(p) => p.theme.navigationBar.search.colorFlex};
  // min-height: 100%;
`;

export const NavbarSearchWrapper = styled.div<{footer?: boolean, isPresentationLMS?: boolean}>`
  display: flex;
  position: absolute;
  left: 16px;
  top: 0;
  cursor: pointer;
  // opacity: 0.47;
  transition: opacity 0.2s;
  align-items: center;
  justify-content: center;
  place-items: center;
  height: 100%;

  svg {
    * {
      fill: ${(p) => p.theme.navigationBar.search.svg} !important;
    }
  }
  &:hover {
    svg {
      * {
        fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
      }
    }
  }

  svg {
    width: ${({footer}) => footer ? '14' : '16'}px !important;
    height: ${({footer}) => footer ? '14' : '16'}px !important;
  }
`;

export const NavbarResultsWrapper = styled.div<{footer?: boolean, isLMS?: boolean}>`
  // position: absolute;
  background-color: ${(p) => p?.isLMS ? '#FEFEFE' : p.theme.mainSearchBar.input.bg};
  max-height: 200px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: ${({ isLMS }) => isLMS ? '0 0px 6px ' : '0 6px 6px '};
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.12);
  margin-bottom: 50px;

  ::-webkit-scrollbar {
    width: 3px; /* ширина scrollbar */
    height: 68px;
  }
  ::-webkit-scrollbar-track {
      background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 10px; /* закругления плашки */
      background-color: ${({ theme }) => theme.scroll.bg};
  }
`;

export const NavbarResultsItem = styled.div<{ isSelected?: boolean, isLMS?: boolean, disabled?: boolean }>`
  display: flex;
  width: 100%;
  height: 52px;
//   border-bottom: 1px solid ${(p) => p.theme.app.ten};
  cursor: ${({disabled}) => disabled ? 'normal' : 'pointer'};
  transition: background-color 0.2s;
  background-color: ${(p) => p?.isLMS ? '#FEFEFE' : p.theme.mainSearchBar.input.bg};
  :hover {
    background-color: ${(p) => p?.disabled ? p.theme.mainSearchBar.input.bg : p.theme.app.ten};
  }
  :active {
    background-color: ${Colors.galBlack31};
  }

  ${({ disabled }) => disabled && css`
    pointer-events: none;
  `}

  .check-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
`;

const DropWrapper = styled.div<{ orientation?: string, isLMS?: boolean }>`
  position: absolute;
  top: 48px;
  left: 0;
  height: auto;
  width: 100%;
  z-index: 400;

  .search-msg {
    color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
    ${({ isLMS }) => isLMS && css`
      background-color: #FEFEFE;
    `};
  }

  .item {
    :not(.search-msg) {
      :hover {
        background-color: ${({ theme, isLMS }) => isLMS ? '#F2F2F2' : theme.mainSearchBar.text.hover.color};
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    top: 40px;
  }
`;

const InputWrapper = styled(FlexBox)<{isPresentationLMS?: boolean}>`
  padding: 0 10px;
  position: relative;
  width: 100%;

  svg path {
    cursor: pointer;
    fill: ${Colors.galBlack47};
    transition: color 0.2s;
  }
  .close-btn-wrap {
    &:hover {
      svg path {
        fill: ${Colors.galBlack100};
        transition: color 0.2s;
      }
    }
  }

  ${({ isPresentationLMS }) => isPresentationLMS ? css`
      padding: 0!important;
    ` : null};
`;

const Text = styled(FInter.SmallTextDiv)`
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
`;

const CloseIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);

  svg {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  svg path {
    fill: ${({ theme }) => theme.projectEdit.search.inputs.fill};
    transition: fill 0.2s;
  }

  :hover {
    svg path {
      fill: ${({ theme }) => theme.projectEdit.search.inputs.hoverFill};
      transition: fill 0.2s;
    }
  }
`;

export interface MainMenuSearchBarProps {
  editing: boolean;
  value: AuthorT[];
  label?: string;
  required?: boolean;
  orientation?: 'row' | 'column' | 'wide';
  onSearch?: (searchValue: string) => Promise<boolean>;
  onAddClick: (data: AuthorT[], { action, removedValue } : AuthorActionsT) => void;
  onResetClick: () => void;
  onSelect?: (id: string) => boolean;
  isProjectEdit?: boolean;
  teamId?: string;
  infoText?: string;
  isTeamEdit?: boolean;
  isLMS?: boolean;
  isPresentationLMS?: boolean;
  ignoreContext?: boolean;
  isPresentation?: boolean;
  isTeacherLMS?: boolean;
  placeholder?: string;
  errorMsg?: string;
  teamModerationType?: number;
  customStyles?: any;
  disabledFocus?: boolean;
  localOptions?: Designer[];
  excludeAccountIds?: string[];
}

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(deps || []), delay]);
};

export const AuthorsMobileSearch: FC<MainMenuSearchBarProps> = ({
  editing = false, 
  ignoreContext, 
  teamId,
  label, 
  isTeacherLMS, 
  value, 
  orientation,
  required,
  isPresentationLMS, 
  errorMsg, 
  onAddClick, 
  onResetClick, 
  onSelect, 
  infoText,
  placeholder, 
  isLMS, 
  teamModerationType,
  customStyles,
  disabledFocus = false,
  localOptions,
  excludeAccountIds,
}) => {
  const searchRef = useRef<any>(null);
  const resultRef = useRef<any>(null);
  const theme = useTheme();
  const toasts = useToasts();
  const [designers, setDesigners] = useState<Designer[]>([]);
  const is568px = useBreakpoint(568)
  const { i18n, t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [isEmpty, setIsEmpty] = useState(false);
  const { id } = useParams<{ id: string }>();
  const isEditLMSExamPage = !!useRouteMatch("/competition-edit");
  const isPro = AppTester.isProDeziiign();
  const isProjectEditPage = !!useRouteMatch("/edit");
  const isBookEditPage = !!useRouteMatch("/books/edit");
  const isEditPage = isProjectEditPage || isBookEditPage;

  const profile = useProfile()
  const isStudent = profile && bProfile.isStudent(profile)

  const showClose = useMemo(() => (!!searchText?.length), [searchText])

  const excludedIds = useMemo(
    () => new Set((excludeAccountIds || []).filter(Boolean)),
    [excludeAccountIds],
  );

  const isExcludedDesigner = useCallback((designer?: Designer | AuthorT | null) => {
    if (!designer || excludedIds.size < 1) {
      return false;
    }
    return excludedIds.has(designer.accountId) || excludedIds.has(designer.designerId);
  }, [excludedIds]);
  
  useDebouncedEffect(
    () => {
      if (searchText.length < 2) {
        setDesigners([]);
        setIsEmpty(false);
        return;
      }

      if (localOptions) {
        const q = searchText.trim().toLowerCase();
        const filtered = localOptions.filter((v) => {
          if (isExcludedDesigner(v)) {
            return false;
          }
          const cv = computeDesigner(v, { showFullName: true });
          const haystack = [cv.fullName, cv.name, cv.surName, cv.middleName, (v as any)?.nameCache]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();
          return haystack.includes(q);
        });
        setDesigners(filtered);
        setIsEmpty(filtered.length < 1);
        return;
      }

      (isTeacherLMS
        ? TeamAPI.OwnersAutoComplete({
            key: searchText,
            teamId: teamId || id,
          })
        : isPresentationLMS
        ? TeamAPI.AutoComplete({ key: searchText, teamId: teamId || id })
        : isLMS && isEditLMSExamPage
        ? DesignerAPI.AutoComplete({ key: searchText, ignoreContext: true })
        : (isLMS)
        ? TeamAPI.AutoComplete({ key: searchText, teamId: teamId || id })
        : (teamModerationType === 3 || ignoreContext)
        ? DesignerAPI.AutoComplete({ key: searchText, ignoreContext: true })
        : DesignerAPI.AutoComplete({ key: searchText })
      )
        .then((v) => v.json())
        .then((v) => API.toLang<Designer[]>(v, i18n.language))
        .then((v) => {
          // @ts-ignore
          if (v?.ErrorStatusCode === 500) {
            setDesigners([]);
            return;
          }
          const filtered = (v || []).filter((designer) => !isExcludedDesigner(designer));
          setDesigners(filtered);
          setIsEmpty(filtered.length < 1);
        });
    },
    [searchText, i18n.language, isLMS, isTeacherLMS, isPresentationLMS, id, teamId, localOptions, isExcludedDesigner],
    700
  );

  useEffect(() => {
    if (searchRef && editing && !is568px && !isPro && !disabledFocus) {
      searchRef.current?.focus();
    }
  }, [searchRef, editing, isPro])

  const resetSearchMode = () => {
    setSearchText('');
    onResetClick();
  }

  const resetText = () => {
    setSearchText('');
    searchRef.current.value = ''
  }

  const handleAddClick = (data: AuthorT[], { action } : AuthorActionsT) => {
    const added = data[data?.length - 1]
    const { designerId } = added || {}
    const isExist = data?.filter((i) => i?.designerId === designerId)?.length > 1

    if (isExcludedDesigner(added)) {
      return;
    }

    if (isExist) {
      toasts.error(errorMsg || 'Нельзя добавить двух одинаковых соавторов');
      return;
    }
    onAddClick && onAddClick(data, { action });
    resetSearchMode(); 
  }

  const handleOnBlurClick = useCallback((ev: any) => {
    if (!resultRef?.current || !designers?.length && !showClose) {
      resetSearchMode();
      return; 
    }
  }, [resetSearchMode, resultRef, designers])

  const handleClose = (ev: any) => {
    if (searchRef.current && !searchRef.current?.contains(ev.target)) {
      resetSearchMode();
      searchRef.current.value = ''
    }
  }

  useEffect(() => {
    window.addEventListener('click', handleClose)
    return () => {
      window.removeEventListener('click', handleClose)
    }
  }, []);

  return (
    <SearchWrapper isProjectEditPage={isEditPage} isStudent={isStudent} orientation={orientation}>
      <CommonInput 
        onChange={(e: any) => setSearchText(e.target.value?.trimLeft())}
        onBlur={handleOnBlurClick}
        ref={searchRef}
        value={searchText}
        type={INPUT_TYPES.search}
        required={required}
        placeholder={placeholder || t('choose')}
        label={label}
        infoText={infoText}
        onWhiteBG
        className="type-theme-input"
        orientation={orientation}
        resultComponent={(
          <>
          {searchText.length > 0 ? (
            <DropWrapper isLMS={isPresentationLMS} className="result-dropdown-wrapper">
            <NavbarResultsWrapper className={'dropdown-wrapper'} style={customStyles} ref={resultRef} isLMS={isPresentationLMS}>
              {designers.map((v) => {
                const cv = computeDesigner(v, { showFullName: true });
                const isSelected = onSelect && onSelect(v?.accountId);
                return (
                  <NavbarResultsItem
                    isLMS={isPresentationLMS}
                    onClick={() => {
                      if (!isSelected) {
                        handleAddClick([...value, v], { action: 'select-option'});
                      }
                    }}
                    key={v.accountId}
                    style={{ marginBottom: '4px', ...customStyles }}
                    className={'item'}
                  >
                    <FlexBox align={"center"} gx={8} style={{ padding: "2px 0 2px 9px", position: 'relative' }} width={'100%'}>
                      <FlexBox width={48} height={48} style={{ borderRadius: '3px' }}>
                        <Avatar {...cv} rounded />
                      </FlexBox>
                      <Text className={'dropdown-wrapper__text'} color={customStyles?.color || theme.mainSearchBar?.text?.color}>{cv.fullName}</Text>
                      {isSelected && (
                        <svg className={'check-icon'} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.7589 5.22636C13.0803 5.52689 13.0803 6.01832 12.7589 6.32014L6.92932 11.773C6.76865 11.9239 6.55856 12 6.34708 12C6.13697 12 5.92682 11.9239 5.76614 11.773L3.24204 9.42346C2.91932 9.12293 2.91932 8.63151 3.24204 8.32969C3.56339 8.02787 4.08387 8.02787 4.40522 8.32969L6.34708 10.1311L11.5944 5.22636C11.9157 4.92455 12.4362 4.92455 12.7589 5.22636Z" fill={theme.mainSearchBar?.text?.color || '#151514'} />
                        </svg>
                      )}
                    </FlexBox>
                  </NavbarResultsItem>
                );
              })}
              {designers.length < 1 && searchText.length < 2 && (
                <NavbarResultsItem  style={customStyles} className="search-msg">
                  <FlexBox
                    align={"center"}
                    width={"100%"}
                    justify={"center"}
                    gx={8}
                  >
                    <Text className={'dropdown-wrapper__text'}>
                      {t("text.more2chars")}
                    </Text>
                  </FlexBox>
                </NavbarResultsItem>
              )}
              {designers.length < 1 && searchText.length >= 2 && !isEmpty && (
                <NavbarResultsItem  style={customStyles} className="search-msg">
                  <FlexBox
                    align={"center"}
                    width={"100%"}
                    justify={"center"}
                    gx={8}
                  >
                    <Text className={'dropdown-wrapper__text'}  >{t("text.loading")}</Text>
                  </FlexBox>
                </NavbarResultsItem>
              )}
              {designers.length < 1 && searchText.length >= 2 && isEmpty && (
                <NavbarResultsItem  style={customStyles} className="search-msg" disabled>
                  <FlexBox
                    align={"center"}
                    width={"100%"}
                    justify={"center"}
                    gx={8}
                  >
                    <Text className={'dropdown-wrapper__text'}>
                    {t("text.notfound")}
                    </Text>
                  </FlexBox>
                </NavbarResultsItem>
              )}
            </NavbarResultsWrapper>
            </DropWrapper>
          ) : null}
          </>
        )}
      />
    </SearchWrapper>
  );
};
